import { faListCheck, faShieldHalved, faUser } from '@fortawesome/free-solid-svg-icons';
import { faChartNetwork, faHouseBlank, faBuildings, faBox } from '@fortawesome/pro-regular-svg-icons';
import { faFiles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getIcon = (icon) => {
  switch (icon) {
    case 'faListCheck':
      return faListCheck;
    case 'faShieldHalved':
      return faShieldHalved;
    case 'faChartNetwork':
      return faChartNetwork;
    case 'faUser':
      return faUser;
    case 'faHouseBlank':
      return faHouseBlank;
    case 'faBuildings':
      return faBuildings;
    case 'faBox':
      return faBox;
    case 'faFiles':
      return faFiles;
    default:
      return null;
  }
};

export const getMenuIcon = (icon) => {
  // check first two chars
  // if (fa) the return <FontAwedpme icon
  //if http then <img src=...
  // mui then Muiicon
  let iconName = icon.substring(0, 2);

  if (iconName === 'fa') {
    return <FontAwesomeIcon icon={getIcon(icon)} />;
  } else if (iconName == 'ht') {
    return <img src={icon} />;
  }
};
